/** Permette di interfacciare l'ordinamento di Ant e TypeOrm */
export enum ColumnSortDirections {
  ascend = 'ASC',
  descend = 'DESC'
}
